angular.module('acme.view.application.importExport.list.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.directive.dataGrid',
    'acme.common.service.offline',
    'acme.common.service.permissions',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.view.application.modals.confirmCustom.controllers',
]).controller( 'ImportExportListController',  [
    '$rootScope',
    '$scope',
    '$state',
    '$timeout',
    '$uibModal',
    'PermissionsService',
    'ImportJobsApiService',
    'JOB_TYPE',
    'GridStateFactory',
    'GridDefinitionFactory',

    function ImportExportListController($rootScope, $scope, $state, $timeout, $uibModal, PermissionsService, ImportJobsApiService, JOB_TYPE, GridStateFactory, GridDefinitionFactory) {

        $scope.importExport = {
            currentStateData: $state.current.data || {},

            init: function() {
                $rootScope.$broadcast('Application::contentTitleChange', { title: self.currentStateData.pageTitle });
                self.setTab(self.JOB_TYPE.IMPORT);
            },

            isActiveTab: function (tab) {
                return this.activeTab === tab;
            },

            getCurrentGrid: function() {
                return  $scope[self.activeTab.toLowerCase() + 'Grid'];
            },

            setTab: function (tab) {
                this.activeTab = tab;

                if (!self.getCurrentGrid().isInitted) {
                    self.initCurrentGrid();
                } else {
                    this.getImportExport();
                }
            },

            JOB_TYPE: JOB_TYPE,
            activeTab: JOB_TYPE.IMPORT,

            optionsOverride: {
                rowHeight: 30,
                // data: 'importGrid.model',
                useAccessibleGrid: true,
                appScopeProvider: {
                    onDataGridPaginate: function(newPage, pageSize, sortField, sortDirection) {
                        self.getCurrentGrid().gridState.updateGridState(newPage, pageSize);
                        if (sortField) {
                            self.getCurrentGrid().gridState.updateGridState(null, null, sortField, null);
                        }
                        if(sortDirection) {
                            self.getCurrentGrid().gridState.updateGridState(null, null, null, sortDirection);
                        }
                        self.getImportExport();
                    },
                    onDataGridSortChange: function(grid, columns, page) {
                        var data = columns[0];
                        self.getCurrentGrid().gridState.updateGridState(page || null, null, data.field, data.sort.direction);
                        self.getImportExport();
                    },
                    onDblClick: function (item) {
                    },
                    createOrUpdateJob: function($event, job) {
                        self.openModal('importExportCreateJobModal',
                            'ImportExportCreateJobModalController',
                            $event, job);
                    },
                    openJobDeleteModal: function ($event, job) {
                        self.openModal('importExportDeleteJobModal',
                            'ImportExportDeleteJobModalController',
                            $event, job);
                    }
                },
                columnDefs: [
                    {
                        displayName: 'ID', name:'id', field: 'id', visible: false
                    }, {
                        field: 'name',
                        displayName: 'Name',
                        visible: true,
                        cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<a data-ui-sref="application.importExport.job({ id: row.entity.id })">{{row.entity.name}}</a>' +
                            '</div>',
                        sort: {
                            direction: 'asc'
                        }
                    }, {
                        field: 'description',
                        displayName: 'Description',
                        visible: true,
                        enableSorting: true
                    }
                ]
            },

            initCurrentGrid: function() {
                self.getCurrentGrid().optionsOverride.data =  self.activeTab.toLowerCase() + 'Grid.model';
                if (PermissionsService.check('IMPEX_JOBS_UPDATE')) {
                    self.getCurrentGrid().optionsOverride.columnDefs.push({
                        field: 'edit',
                        name: 'edit',
                        displayName: 'Edit',
                        width: 60,
                        enableSorting: false,
                        onCellNavClick: function(row, col) {
                            self.getCurrentGrid().optionsOverride.appScopeProvider.createOrUpdateJob(null, row.entity);
                        },
                        cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">' +
                            '<a data-ng-click="grid.appScope.createOrUpdateJob($event, row.entity)">' +
                            'Edit <span class="sr-only">Job</span>' +
                            '</a>' +
                            '</div>'
                    });
                }

                if (PermissionsService.check('IMPEX_JOBS_DELETE')) {
                    self.getCurrentGrid().optionsOverride.columnDefs.push({
                        field: 'delete',
                        name: 'delete',
                        displayName: 'Delete',
                        width: 60,
                        enableSorting: false,
                        onCellNavClick: function(row, col) {
                            if (row.entity.jobExecutionCount === 0) {
                                self.getCurrentGrid().optionsOverride.appScopeProvider.openJobDeleteModal(null, row.entity);
                            }
                        },
                        cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()">' +
                            '<a data-ng-show="row.entity.jobExecutionCount === 0" data-ng-click="grid.appScope.openJobDeleteModal($event, row.entity)">' +
                            'Delete <span class="sr-only">Job</span>' +
                            '</a>' +
                            '</div>'
                    });
                }

                self.getCurrentGrid().gridDefinition.init(self.getCurrentGrid().gridName, self.getCurrentGrid().optionsOverride, $state.current.name, self.currentStateData.enablePreferences);

                $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', self.initData));

                self.getCurrentGrid().isInitted = true;
            },

            initData: function(e, data) {
                var props = self.getCurrentGrid().gridDefinition.getGridState();
                self.getCurrentGrid().gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
                self.getImportExport();
            },

            getImportExport: function() {
                var gridState = self.getCurrentGrid().gridState.getGridState();
                var sortField = null;
                if (gridState.sortField && gridState.sortDirection) {
                    sortField = gridState.sortField + "," + gridState.sortDirection;
                }
                ImportJobsApiService.list(
                    gridState.page - 1,
                    gridState.pageSize,
                    sortField,
                    self.activeTab
                ).then(self.success.getData, self.error.getData);
            },

            showServiceUnavailable: function() {
                var modalInstance = $uibModal.open({
                  size: 'md',
                  controller: 'ConfirmCustomModalController',
                  templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
                  resolve: {
                    modalTitle: function () {
                      return 'Error';
                    },
                    okText: function () {
                      return '';
                    },
                    cancelText: function () {
                      return 'Close';
                    },
                    modalMessage: function () {
                      return '<p class="text-center">The service is currently unavailable. Please try again later.</p>';
                    },
                    hideOkText: function () {
                      return true;
                    },
                  },
                });
            },

            serviceUnavailable: false,

            success: {
                init: function(response) {},
                getData: function (response) {
                    var data = response.data;

                    if (!data || !data.page) {
                      self.serviceUnavailable = true;
                      self.showServiceUnavailable();
                      return;
                    }

                    self.getCurrentGrid().model = data._embedded ? data._embedded.jobVoList : [];

                    self.getCurrentGrid().isLoaded = true;
                    self.getCurrentGrid().loading = false;
                    self.getCurrentGrid().gridDefinition.isLoaded = true;

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }

                    $timeout(function() {
                        $scope.$broadcast('DataGrid::ResizeGrid', {
                            name: self.getCurrentGrid().gridName,
                            datasetLength: self.getCurrentGrid().model.length,
                            totalItems: data.page.totalElements
                        });

                    }, 10);
                }
            },

            error: {
                init: function(response) {},
                getData: function (data) {
                    self.serviceUnavailable = true;
                    self.showServiceUnavailable();
                }
            },

            openModal: function(template, controller, $event, job) {
                if ($event && $event.preventDefault) {
                    $event.preventDefault();
                }

                var modal = $uibModal.open({
                    templateUrl: 'views/application/views/importExport/list/' + template + '.tpl.html',
                    size: 'md',
                    controller: controller,
                    controllerAs: '$ctrl',
                    resolve: {
                        type: function () {
                            return self.activeTab;
                        },
                        job: function () {
                            return job;
                        }
                    }
                });

                modal.result.then(function (wasAddedOrDeleted) {
                    if (wasAddedOrDeleted) {
                        self.getImportExport();
                    }
                });
            }

        };


        var self = $scope.importExport;

        $scope.importGrid = {
            gridName: $state.current.name+'.grid.import',
            gridDefinition: new GridDefinitionFactory(),
            gridState: new GridStateFactory(),
            isLoaded: true,
            model: [],
            filtered: [],
            isRemoving: false,
            searchQuery: '',
            queryTimer: false,
            customFields: [],
            optionsOverride: angular.copy(self.optionsOverride)
        };

        $scope.exportGrid = {
            gridName: $state.current.name+'.grid.export',
            gridDefinition: new GridDefinitionFactory(),
            gridState: new GridStateFactory(),
            isLoaded: true,
            model: [],
            filtered: [],
            isRemoving: false,
            searchQuery: '',
            queryTimer: false,
            customFields: [],
            optionsOverride: angular.copy(self.optionsOverride)
        };

        self.init();

    }]);
